export default __webpack_public_path__ + "components/wind-icon/static/ESE@2x-8d3cf51194819f7b8c6379cbad3e445c.png";